import CustomSelect from 'designer/component/element/Select'
import objectPath from 'object-path'

const SelectControl = (props) => {
  const { uischema, handleChange, path, config } = props
  const data = config?.jsonData
  const { optionType, valueJoin = '', valueType, isMulti } = uischema
  const optionValue = objectPath.get(uischema, `${optionType}.optionValue`)
  const valueKey = objectPath.get(uischema, `${optionType}.valueKey`)

  const updateValue = async (value) => {
    handleChange(path, value)
  }

  const setValue = (value) => {
    if (isMulti && value) {
      let preview = []
      value.forEach((item) => {
        let itemValue = objectPath.get(item, optionValue)
        if (itemValue) {
          preview.push(itemValue)
        }
      })
      if (valueType === 'string') {
        return preview.join(valueJoin)
      }
      return preview
    }
    return objectPath.get(value, optionValue)
  }

  const updateOtherValue = (option) => {
    if (valueKey) {
      Object.keys(valueKey).forEach((key) => {
        let value = objectPath.get(option, key)
        let name = objectPath.get(valueKey, key)
        handleChange(name, value)
      })
    }
  }

  const updateData = (option) => {
    let newValue = setValue(option)
    updateValue(newValue)
    updateOtherValue(option)
  }

  return (
    <CustomSelect
      {...props}
      uischema={uischema}
      value={data}
      updateData={updateData}
      uiKey={uischema.key}
      data={data}
    />
  )
}

export default SelectControl
